<!--
 * @Description: 合同签署回调
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div></div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import native from '@/utils/native';

onMounted(() => {
  setTimeout(() => {
    native.method.contractSignDone();
  }, 500);
});
</script>
